import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Link, Typography } from '@mui/material'
import { getAuth } from 'firebase/auth'
import { useState } from 'react'

import { ConfirmDialog } from '../Confirm/Dialog'
import { useSnackbar } from '../Snackables'

const submitErasureRequest = async (): Promise<{ success: boolean; error?: string }> => {
  const user = getAuth().currentUser
  if (!user) {
    return { success: false, error: 'Not authenticated' }
  }

  const token = await user.getIdToken()
  const response = await fetch('https://prod.coinapp.co/manager/foursquare/erasure-request', {
    method: 'POST',
    headers: {
      'x-auth-token': token,
    },
  })

  if (!response.ok) {
    if (response.status === 404) {
      return { success: false, error: 'No data sharing is active for your account.' }
    }
    const data = await response.json().catch(() => ({}))
    return { success: false, error: data.error || 'Request failed' }
  }

  return { success: true }
}

export function DoNotSell() {
  const [confirmOpen, setConfirmOpen] = useState(false)
  const [successOpen, setSuccessOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const { setSnackbar } = useSnackbar()[1]

  const handleConfirm = async () => {
    setLoading(true)
    try {
      const result = await submitErasureRequest()
      setConfirmOpen(false)
      if (result.success) {
        setSuccessOpen(true)
      } else {
        setSnackbar({
          autoHideDuration: 6000,
          message: result.error || 'Failed to submit request',
          severity: 'error',
        })
      }
    } catch {
      setConfirmOpen(false)
      setSnackbar({
        autoHideDuration: 6000,
        message: 'An unexpected error occurred. Please try again.',
        severity: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <Link component="button" onClick={() => setConfirmOpen(true)} underline="hover">
        Do Not Sell or Share My Personal Information
      </Link>

      <ConfirmDialog
        open={confirmOpen}
        title="Do Not Sell"
        loading={loading}
        onClose={() => setConfirmOpen(false)}
        onConfirm={handleConfirm}
      >
        <Typography>Are you sure you want to submit a Do Not Sell request?</Typography>
      </ConfirmDialog>

      <Dialog open={successOpen} onClose={() => setSuccessOpen(false)} fullWidth maxWidth="xs">
        <DialogTitle>Request Submitted</DialogTitle>
        <DialogContent>
          <Typography>
            Your request has been submitted. Please turn off the following settings in the COIN app to prevent further
            data collection: Rewarded Surveys, Store Visits, and Product Scans, Video Ads, Audio Ads, and Location
            Services in your OS settings for the app. If you would like to delete your account completely, you can do so
            from COIN app settings. Any questions, please reach out to support at{' '}
            <Link href="https://support.coinapp.co/hc/en-us/requests/new" target="_blank" rel="noopener noreferrer">
              Submit a request
            </Link>
            .
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setSuccessOpen(false)} variant="contained" color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
